import {PayloadItemModel} from '../../../../../../../../core';
import {SearchEntity} from '../entity/search.models';

export class CreatePayload extends PayloadItemModel<SearchEntity> {
}
